<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'home' }">{{ $t("inicio") }}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'informes' }">{{ $t("informes") }}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{ $t("ventasDeCategorias") }}</li>
                    </ol>
                </nav>
            </div>
            <CabeceraInformes :idBusiness="idBusiness" :listBusinesses="listBusinesses" :idTpv="idTpv"
                :listTpv="listTpv" :dateto="dateto" :datefrom="datefrom" id="cabecera" :conTodos="true" />
            <!--<div class="col-md-12">
                <div class="card">
                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="listBusiness">{{$t("negocio")}}</label>

                                <el-select class="select-default"
                                           size="large"
                                           v-model="idBusiness"
                                           filterable
                                           :placeholder="$t('seleccionaNegocio')"
                                           @change="getTpv(),idsTPV=[]">
                                    <el-option v-for="business in listBusinesses"
                                               class="select-primary"
                                               :value="business.id"
                                               :label="business.establishmentName"
                                               :key="business.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">

                                <label for="listTPV">{{$t("TPV")}}</label>

                                <div class="row">
                                    <div class="col-8">
                                        <el-select class="select-default"
                                                   size="large"
                                                   v-model="idTpv"
                                                   filterable
                                                   @change="changeTPV()"
                                                   :placeholder="$t('seleccionaNegocio')">
                                            <el-option v-for="tpv in listTpv"
                                                       class="select-primary"
                                                       :value="tpv.id"
                                                       :label="tpv.nameShow"
                                                       :key="tpv.id">
                                            </el-option>
                                        </el-select>
                                    </div>

                                    <div class="col-4">
                                        <button class="btn btn-primary"
                                                @click="openModal()"><i
                                                class="fa fa-filter"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="col-md-2">
                         <div class="form-group">
                             <label for="listBusiness">{{$t("TPV")}}</label>
                             <el-select class="select-default"
                                        size="large"
                                        v-model="idTpv"
                                        filterable
                                        placeholder="Selecciona negocio..."
                                        @change="getSalesCategories()">
                                 <el-option v-for="tpv in listTpv"
                                            class="select-primary"
                                            :value="tpv.id"
                                            :label="tpv.nameShow"
                                            :key="tpv.nameShow">
                                 </el-option>
                             </el-select>
                         </div>
                     </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label>{{$t("fechaInicio")}}</label>
                                <datetime
                                        value-zone="Europe/Madrid"
                                        :auto="true"
                                        class="theme-numier"
                                        format="dd-MM-yyyy"
                                        :title="$t('fechaInicio')"
                                        :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                        input-class="form-control"
                                        v-model="datefrom"></datetime>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label>{{$t("fechaFin")}}</label>
                                <datetime
                                        value-zone="Europe/Madrid"
                                        :auto="true"
                                        class="theme-numier"
                                        :title="$t('fechaFin')"
                                        format="dd-MM-yyyy"
                                        :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                        input-class="form-control"
                                        v-model="dateto"></datetime>
                            </div>
                        </div>



                        <div class="col-md-2">
                            <label>&nbsp;</label>
                            <div class="form-group">
                                <button class="btn btn-primary" @click="getSalesCategories()">
                                    <img src="static/img/sync.gif" alt="" v-if="loading" width="15">
                                    {{$t("consultar")}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>-->

            <!--<cabecera-informes :idBusiness="idBusiness" :idTpv="idTpv" :listBusinesses="listBusinesses"
                               :dates="value4" :listTpv="listTpv"></cabecera-informes>-->

            <template v-if="!permiso">
                <div class="alert alert-danger m-3" style="width: 100%" role="alert">
                    Lo sentimos. Este negocio no cuenta con este módulo activado.
                </div>
            </template>
            
            <div class="col-md-8" v-else-if="respuesta">
                <template v-if="list.length > 0">
                    <div class="row">
                        <div v-if="nameCate !== ''" class="col-md-12">
                            <h4 style="margin: 0px 0px 10px 0px">{{ $t("ventasCategoriaDe") }} <span
                                    class="text-primary">{{ nameCate }}</span>
                            </h4>
                        </div>

                        <div v-if="nameCate !== ''" class="col-md-3">
                            <button @click="volver()" class="btn btn-primary btn-sm"><i
                                    class="fas fa-arrow-circle-left"></i>
                                {{ $t("volverAGeneral") }}
                            </button>
                        </div>
                        <div v-if="nameCate === ''" class="col-md-5">
                            <el-switch v-if="existeProducto == true" v-model="checkValue" active-color="#13ce66"
                                inactive-color="#bcbcbc" @change="emitirConsulta()">
                            </el-switch>
                            <label v-if="existeProducto == true">
                                <strong>
                                    {{ $t('noMostrarDescuento') }}
                                </strong>
                            </label>
                        </div>
                        <div
                            :class="!hayMenus ? existeProducto ? 'col-md-9 text-right col-xs-12 div-export' : 'col-md-12 text-right col-xs-12 div-export' : 'col-md-7 text-right col-xs-12 div-export'">
                            <div class="float-left mb-2" v-if="hayMenus">
                                <label style="font-size:0.8em">
                                    <strong>{{ $t('excluirPrecioMedioMenu') }}</strong>
                                </label>

                                <el-switch v-model="excluirMenu" active-color="#13ce66" inactive-color="#bcbcbc">
                                </el-switch>
                            </div>
                            <el-dropdown>
                                <el-button type="primary" size="small">
                                    <i class="fa fa-file"></i>
                                    {{ $t("exportarInforme") }} <i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>


                                <template v-if="nameCate == ''">
                                    <el-dropdown-menu slot="dropdown">
                                        <a :href="urlExportPDF">
                                            <el-dropdown-item class="text-danger">
                                                <strong><i class="fa fa-file-pdf"></i> {{ $t("exportarPdf") }}</strong>
                                            </el-dropdown-item>
                                        </a>
                                        <a :href="urlExportExcel">
                                            <el-dropdown-item class="text-success">
                                                <strong><i class="fa fa-file-excel"></i> {{ $t("exportarExcel") }}</strong>
                                            </el-dropdown-item>
                                        </a>
                                    </el-dropdown-menu>
                                </template>
                                <template v-else>
                                    <el-dropdown-menu slot="dropdown">
                                        <a :href="urlExportPDFDetalle">
                                            <el-dropdown-item class="text-danger">
                                                <strong><i class="fa fa-file-pdf"></i> {{ $t("exportarPdf") }}</strong>
                                            </el-dropdown-item>
                                        </a>
                                        <a :href="urlExportExcelDetalle">
                                            <el-dropdown-item class="text-success">
                                                <strong><i class="fa fa-file-excel"></i> {{ $t("exportarExcel") }}</strong>
                                            </el-dropdown-item>
                                        </a>
                                    </el-dropdown-menu>
                                </template>
                            </el-dropdown>
                        </div>

                        <!--TABLA CATEGORIAS-->

                        <div v-if="nameCate === ''" class="col-md-12">
                            <div class="table-responsive">
                                <table class="table table-bordered table-striped text-nowrap" style="table-layout: fixed">
                                    <thead class="thead-dark">
                                        <tr style="cursor: pointer;">
                                            <th style="width: 20%; overflow: hidden" v-if="ordenacionProductos === 0" @click="sortedArrayNameASC('name')"><i
                                                    style="color: white" class="fa fa-angle-up"></i> {{ $t("categoria") }}
                                            </th>
                                            <th style="width: 20%; overflow: hidden" v-else @click="sortedArrayNameDESC('name')"><i style="color: white"
                                                    class="fa fa-angle-down"></i> {{ $t("informes") }}
                                            </th>
                                            <th style="overflow: hidden" v-if="ordenarCantidad === 0" @click="sortedArrayCantidadASC('cantidad')">
                                                <i style="color: white" class="fa fa-angle-up"></i> {{ $t("cantidad") }}
                                            </th>
                                            <th style="overflow: hidden" v-else @click="sortedArrayCantidadDESC('cantidad')"><i
                                                    style="color: white" class="fa fa-angle-down"></i>
                                                {{ $t("cantidad") }}
                                            </th>
                                            <template v-if="hayMenus">
                                                <th style="overflow: hidden" v-if="ordenarCantidadMenu === 0"
                                                    @click="sortedArrayCantidadMenuCategASC('cantidadMenu')"
                                                    v-tooltip.top-center="'Cantidad en menús'">
                                                    <i style="color: white" class="fa fa-angle-up"></i>
                                                    C. en Menús
                                                </th>
                                                <th style="overflow: hidden" v-else @click="sortedArrayCantidadMenuCategDESC('cantidadMenu')"
                                                    v-tooltip.top-center="'Cantidad en menús'">
                                                    <i style="color: white" class="fa fa-angle-down"></i>
                                                    C. en Menús
                                                </th>
                                                <th style="width: 15%; overflow: hidden" v-if="ordenarCantidadMenuDiferencia === 0"
                                                    @click="sortedArrayCantidadMenuCategDiferenciaASC('cantidadDiferencia')"
                                                    v-tooltip.top-center="'Cantidad fuera de menús'">
                                                    <i style="color: white" class="fa fa-angle-up"></i>
                                                    C. Fuera de Menús
                                                </th>
                                                <th style="width: 15%; overflow: hidden" v-else
                                                    @click="sortedArrayCantidadMenuCategDiferenciaDESC('cantidadDiferencia')"
                                                    v-tooltip.top-center="'Cantidad fuera de menús'">
                                                    <i style="color: white" class="fa fa-angle-down"></i>
                                                    C. Fuera de Menús
                                                </th>
                                            </template>
                                            <th style="overflow: hidden" v-if="ordenarImporte === 0" @click="sortedArrayImporteASC('importe')"><i
                                                    style="color: white" class="fa fa-angle-up"></i> {{ $t("importeConIva") }}
                                            </th>
                                            <th style="overflow: hidden" v-else @click="sortedArrayImporteDESC('importe')"><i
                                                    style="color: white" class="fa fa-angle-down"></i> {{ $t("importeConIva") }}
                                            </th>
                                            <th style="overflow: hidden" v-if="ordenarImporteSinIva === 0" @click="sortedArrayImporteSinIvaASC('importeSinIva')"><i
                                                    style="color: white" class="fa fa-angle-up"></i> {{ $t("importeSinIva") }}
                                            </th>
                                            <th style="overflow: hidden" v-else @click="sortedArrayImporteSinIvaDESC('importeSinIva')"><i
                                                    style="color: white" class="fa fa-angle-down"></i> {{ $t("importeSinIva") }}
                                            </th>
                                            <th style="overflow: hidden" v-if="ordenarPrecioMed === 0"
                                                @click="sortedArrayPrecioMedASC('importe/cantidad')"><i
                                                    style="color: white" class="fa fa-angle-up"></i> {{ $t("precioMed") }}
                                            </th>
                                            <th style="overflow: hidden" v-else @click="sortedArrayPrecioMedDESC('importe/cantidad')"><i
                                                    style="color: white" class="fa fa-angle-down"></i>
                                                {{ $t("precioMed") }}
                                            </th>
                                            <th style="width: 15%; overflow: hidden" v-if="ordenarPorcentaje === 0"
                                                @click="sortedPorcentajeASC('importe')"><i
                                                    style="color: white" class="fa fa-angle-up"></i> {{$t("porcentajeRespectoTotal")}}
                                            </th>
                                            <th style="width: 15%; overflow: hidden" v-else @click="sortedPorcentajeDESC('importe')"><i
                                                    style="color: white" class="fa fa-angle-down"></i> {{$t("porcentajeRespectoTotal")}}
                                            </th>
                                            <th>{{ $t("acciones") }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(obj, index) in list" :key="index">
                                            <td style="width: 25%; overflow: hidden">{{ obj.name }}</td>

                                            <!-- <td v-if="checkValue==true" class="text-right">{{obj.cantidad}}</td>
                                        <td v-else class="text-right">{{obj.cantidad}}</td> -->
                                            <td class="text-right">{{ getTotalUdsCategoria(obj.products) }}</td>
                                            <template v-if="hayMenus">
                                                <td class="text-right">{{ getTotalUdsCategoriaMenu(obj.products) }}</td>
                                                <td style="width: 15%" class="text-right">{{ getTotalUdsCategoria(obj.products) -
                                                        getTotalUdsCategoriaMenu(obj.products)
                                                }}</td>
                                            </template>
                                            <!-- <td>{{getTotalUdsProduct}}</td> -->

                                            <td v-if="checkValue && obj.importe >= 0" class="text-right">{{ obj.importe |
                                                    currency
                                            }}</td>
                                            <td v-else class="text-right">{{ obj.importe | currency }}</td>
                                            <td class="text-right">{{ obj.importeSinIva | currency }}</td>
                                            <!-- <td>{{getTotalPrecioProduct | currency}}</td> -->
                                            <td class="text-right">{{ calcularMedia(obj) | currency }}</td>
                                            <td style="width: 15%" class="text-right">{{ getPorcentajeCategorias(obj.importe) }} %</td>
                                            <td align="center">
                                                
                                                <i v-if="obj.products.length > 0" class="fas fa-arrow-circle-right"
                                                    style="cursor: pointer"
                                                    v-tooltip.top-center="$t('desgloseDeVentasPorProductos')"
                                                    @click="accionarProductByCate(index, obj)"></i>

                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr class="table-success">
                                            <td style="width: 25%; overflow: hidden"><strong>{{ $t("total") }}</strong></td>
                                            <td class="text-right"><strong>{{ getTotalUds }}</strong></td>
                                            <template v-if="hayMenus">
                                                <td class="text-right"><strong>{{ getTotalUdsCategMenus }}</strong></td>
                                                <td style="width: 15%" class="text-right"><strong>{{ getTotalUds -
                                                        getTotalUdsCategMenus
                                                }}</strong></td>
                                            </template>
                                            <td class="text-right"><strong>{{ getTotalPrecio | currency }}</strong></td>
                                            <td class="text-right"><strong>{{ getTotalPrecioSinIva | currency }}</strong></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>

                        <!--TABLA PRODUCTOS-->

                        <div v-if="nameCate !== ''" class="table-responsive col-md-12">
                            <table class="table table-bordered table-striped text-nowrap" style="table-layout: fixed">
                                <thead class="thead-dark" style="cursor: pointer;">
                                    <tr>
                                        <th style="width: 25%; overflow: hidden" v-if="ordenacionProductos === 0" @click="sortedArrayNameASC('name')"><i
                                                style="color: white" class="fa fa-angle-up"></i> {{ $t("producto") }}
                                        </th>
                                        <th style="width: 25%; overflow: hidden" v-else @click="sortedArrayNameDESC('name')"><i style="color: white"
                                                class="fa fa-angle-down"></i> {{ $t("producto") }}
                                        </th>
                                        <th style="overflow: hidden" v-if="ordenarCantidad === 0" @click="sortedArrayCantidadASC('cantidad')"><i
                                                style="color: white" class="fa fa-angle-up"></i> {{ $t("cantidad") }}
                                        </th>
                                        <th style="overflow: hidden" v-else @click="sortedArrayCantidadDESC('cantidad')"><i style="color: white"
                                                class="fa fa-angle-down"></i> {{ $t("cantidad") }}
                                        </th>
                                        <template v-if="hayMenus">
                                            <th style="overflow: hidden" v-if="ordenarCantidadMenu === 0"
                                                @click="sortedArrayCantidadMenuASC('cantidadMenu')"
                                                v-tooltip.top-center="'Cantidad en menús'">
                                                <i style="color: white" class="fa fa-angle-up"></i>
                                                C. en Menús
                                            </th>
                                            <th style="overflow: hidden" v-else @click="sortedArrayCantidadMenuDESC('cantidadMenu')"
                                                v-tooltip.top-center="'Cantidad en menús'">
                                                <i style="color: white" class="fa fa-angle-down"></i>
                                                C. en Menús
                                            </th>
                                            <th style="width: 15%; overflow: hidden" v-if="ordenarCantidadMenuDiferencia === 0"
                                                @click="sortedArrayCantidadMenuDiferenciaASC('cantidadDiferencia')"
                                                v-tooltip.top-center="'Cantidad fuera de menús'">
                                                <i style="color: white" class="fa fa-angle-up"></i>
                                                C. Fuera de Menús
                                            </th>
                                            <th style="width: 15%; overflow: hidden" v-else
                                                @click="sortedArrayCantidadMenuDiferenciaDESC('cantidadDiferencia')"
                                                v-tooltip.top-center="'Cantidad fuera de menús'">
                                                <i style="color: white" class="fa fa-angle-down"></i>
                                                C. Fuera de Menús
                                            </th>
                                        </template>
                                        <th style="overflow: hidden" v-if="ordenarImporte === 0" @click="sortedArrayImporteASC('importe')"><i
                                                style="color: white" class="fa fa-angle-up"></i> {{ $t("importeConIva") }}
                                        </th>
                                        <th style="overflow: hidden" v-else @click="sortedArrayImporteDESC('importe')"><i style="color: white"
                                                class="fa fa-angle-down"></i> {{ $t("importeConIva") }}
                                        </th>
                                        <th style="overflow: hidden" v-if="ordenarImporteSinIva === 0" @click="sortedArrayImporteSinIvaASC('importeSinIva')"><i
                                                style="color: white" class="fa fa-angle-up"></i> {{ $t("importeSinIva") }}
                                        </th>
                                        <th style="overflow: hidden" v-else @click="sortedArrayImporteSinIvaDESC('importeSinIva')"><i style="color: white"
                                                class="fa fa-angle-down"></i> {{ $t("importeSinIva") }}
                                        </th>
                                        <th style="overflow: hidden" v-if="ordenarPrecioMed === 0"
                                            @click="sortedArrayPrecioMedASC('importe/cantidad')"><i style="color: white"
                                                class="fa fa-angle-up"></i> {{ $t("precioMed") }}
                                        </th>
                                        <th style="overflow: hidden" v-else @click="sortedArrayPrecioMedDESC('importe/cantidad')"><i
                                                style="color: white" class="fa fa-angle-down"></i> {{ $t("precioMed") }}
                                        </th>
                                        <th style="width: 15%; overflow: hidden" v-if="ordenarPorcentaje === 0" @click="sortedPorcentajeASC('importe')"><i
                                                style="color: white" class="fa fa-angle-up"></i> {{$t("porcentajeRespectoTotal")}}
                                        </th>
                                        <th style="width: 15%; overflow: hidden" v-else @click="sortedPorcentajeDESC('importe')"><i style="color: white"
                                                class="fa fa-angle-down"></i> {{$t("porcentajeRespectoTotal")}}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <!-- <tr v-for="obj in listProduct"> -->

                                    <tr v-if="checkValue == true" v-for="obj in listProduct">
                                        <td style="width: 25%; overflow: hidden" v-if="obj.importe >= 0">
                                            <span style="color:#458195; cursor: pointer;" v-if="obj.menusPertenecientes.length > 0" @click="abrirModalDetallesMenu(obj)">
                                                <i class="fas fa-list" style="font-weight: bold; font-size: 1.1em"></i>
                                                    {{ obj.name }}
                                            </span>
                                            <span v-else>{{ obj.name }}</span> 
                                        </td>
                                        <td v-if="obj.importe >= 0" class="text-right">{{ obj.cantidad }}</td>
                                        <template v-if="hayMenus">
                                            <td style="width:10%" class="text-right">
                                                <span class="text-primary" v-if="obj.pedirPeso">{{ obj.cantidadMenu }}
                                                    Kg.</span>
                                                <span v-else class="text-righ">{{ obj.cantidadMenu }}</span>
                                            </td>
                                            <td style="width:15%" class="text-right">
                                                <span class="text-primary" v-if="obj.pedirPeso">{{ obj.cantidad -
                                                        obj.cantidadMenu
                                                }} Kg.</span>
                                                <span v-else class="text-righ">{{ obj.cantidad -
                                                        obj.cantidadMenu
                                                }}</span>
                                            </td>
                                        </template>
                                        <td v-if="obj.importe >= 0" class="text-right">{{ obj.importe | currency }}</td>
                                        <td v-if="obj.importe >= 0" class="text-right">{{ obj.importeSinIva | currency }}</td>
                                        <td v-if="obj.importe >= 0" class="text-right">{{ calcularMedia(obj) | currency }}</td>
                                        <td style="width: 15%" class="text-right">{{ getPorcentajeProductos(obj.importe) }} %</td>
                                    </tr>

                                    <tr v-if="checkValue == false" v-for="obj in listProduct">
                                        <td style="width: 25%; overflow: hidden">
                                            <span style="color:#458195; cursor: pointer;" v-if="obj.importe >= 0 && obj.menusPertenecientes.length > 0" @click="abrirModalDetallesMenu(obj)">
                                                <i class="fas fa-list" style="font-weight: bold; font-size: 1.1em"></i>
                                                    {{ obj.name }}
                                                </span>
                                                <span v-else>
                                                    {{ obj.name }}
                                                </span> 
                                        </td>
                                        <td class="text-right">{{ obj.cantidad }}</td>
                                        <template v-if="hayMenus">
                                            <td style="width:10%" class="text-right">
                                                <span class="text-primary" v-if="obj.pedirPeso">{{ obj.cantidadMenu }}
                                                    Kg.</span>
                                                <span v-else class="text-righ">{{ obj.cantidadMenu }}</span>
                                            </td>
                                            <td style="width:15%" class="text-right">
                                                <span class="text-primary" v-if="obj.pedirPeso">{{ obj.cantidad -
                                                        obj.cantidadMenu
                                                }} Kg.</span>
                                                <span v-else class="text-righ">{{ obj.cantidad -
                                                        obj.cantidadMenu
                                                }}</span>
                                            </td>
                                        </template>
                                        <td class="text-right">{{ obj.importe | currency }}</td>
                                        <td class="text-right">{{ obj.importeSinIva | currency }}</td>
                                        <td class="text-right">{{ calcularMedia(obj) | currency }}</td>
                                        <td style="width: 15%" class="text-right">{{ getPorcentajeProductos(obj.importe) }} %</td>
                                    </tr>

                                </tbody>
                                <tfoot>
                                    <tr class="table-success">
                                        <td style="width: 25%; overflow: hidden"><strong>{{ $t("total") }}</strong></td>
                                        <td class="text-right">
                                            <strong>{{ getTotalUdsProduct }}</strong>
                                            <i v-tooltip.top-center="$t('recuerdeQueLasLineasDeDescuentoNoSeSumanAlTotal')"
                                                style="cursor: pointer; padding-right:15px" class="fa fa-info-circle">
                                            </i>
                                        </td>
                                        <template v-if="hayMenus">
                                            <td class="text-right">
                                                <strong>{{ getTotalUdsMenus }}</strong>
                                            </td>
                                            <td style="width: 15%" class="text-right">
                                                <strong>{{ getTotalUdsProduct - getTotalUdsMenus }}</strong>
                                            </td>
                                        </template>
                                        <td class="text-right"><strong>{{ getTotalPrecioProduct | currency }}</strong>
                                        </td>
                                        <td class="text-right"><strong>{{ getTotalPrecioProductSinIva | currency }}</strong></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="alert alert-danger" role="alert">
                        {{ $t("noHay") }} <strong>{{ $t("ventasDeProductosMinusculas") }}</strong> {{ $t("rangoDeFechas") }}
                    </div>
                </template>
            </div>

            <div class="col-md-4 " v-show="this.list.length > 0 && respuesta && permiso">

                <div class="card">

                    <button v-if="chartIn === 0" @click="chartIn = 1, initChart()" class="btn btn-primary col-md-12">
                        {{ $t("porUnidad") }}
                    </button>
                    <button v-else @click="chartIn = 0, initChart()" class="btn btn-primary col-md-12">
                        {{ $t("porImporte") }}
                    </button>

                    <div class="chart-container col-md-12 " style="height:40vh;">
                        <canvas id="chart"></canvas>
                    </div>

                </div>
            </div>

            <modal name="filtradoTPV" :adaptive=true :scrollable=true height="auto" :clickToClose=true>
                <div>
                    <div class="modal-header">
                        <h4 style="margin: 0px">{{ $t("filtrarPorTPV") }}</h4>
                    </div>
                    <div class="modal-body">

                        <el-checkbox-group :min="1" v-model="idsTPV" size="medium">
                            <el-checkbox v-for="tpv in listCheckBoxTpv" :label=tpv.id :key="tpv.id" border>
                                {{ tpv.nameShow }}
                            </el-checkbox>
                        </el-checkbox-group>


                    </div>
                    <div class="modal-footer">
                        <div align="right" class="col-12">
                            <button class="btn btn-primary" @click="getSalesCategories()"><i class="fa fa-search"></i>
                                {{ $t("filtrarTPV") }}
                            </button>
                        </div>
                    </div>
                </div>
            </modal>
            <modal name="detallesMenu" :adaptive="true" :scrollable="true" height="auto" :clickToClose="true">
                <div>
                    <div class="modal-header">
                        <h5 style="margin: 0px">
                            Veces que se ha vendido dentro de menús
                        </h5>
                    </div>
                    <div class="modal-body">
                        <div class="table-responsive" style="overflow: auto">
                            <table class="table table-bordered table-striped ">
                                <thead class="thead-dark">
                                    <tr>
                                        <th style="width:90%">{{ $t("nombre") }} del menú</th>
                                        <th>{{ $t("cantidad") }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(prod) in listaDetallesMenu" :key="prod.id + Math.random()">
                                        <td>{{ prod.name }}</td>
                                        <td>{{ prod.cantidad }}</td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr></tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-default" @click="cerrarModalDetallesMenu()">
                            <i class="fa fa-times-circle"></i>
                            {{ $t("cerrar") }}
                        </button>
                    </div>
                </div>
            </modal>
        </div>
    </div>

</template>
<script>
import Datepicker from 'vuejs-datepicker';
import Chart from 'chart.js';
import {
    DatePicker, Select, Option, Dropdown, DropdownItem, DropdownMenu, Button,
    Checkbox,
    CheckboxGroup,
    Loading, Switch,
} from 'element-ui'
import swal from 'sweetalert2'
import moment from 'moment'
import CabeceraInformes from "@/components/CabeceraInformes/CabeceraInformes.vue";
import bus from '../../../../bus'
import { mapState } from 'vuex'

export default {
    created() {
        this.loading = Loading.service({ text: "Cargando..." });
        this.$store.dispatch("setNameRoute", this.$i18n.t("ventasDeCategorias"));
        this.getBusiness();

        if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {
            this.datefrom = this.$store.getters.dateFrom;
            this.dateto = this.$store.getters.dateTo;
        }

        bus.$on('get-ventas', (item) => {
            this.getVentas();
        });

        bus.$on('get-business', (idBusiness) => {
            this.idBusiness = idBusiness;
            this.idsTPV = [];
            this.idTpv = 0;

            this.getTpv();
        });

        bus.$on('get-tpv', (idTpv) => {
            this.idTpv = idTpv;

            this.changeTPV();
        });

        bus.$on('get-date', (dates) => {
            this.value4 = dates;

            this.getSalesCategories();
        });

        bus.$on('get-open-modal', (item) => {
            this.openModal();
        });
    },
    components: {
        //CabeceraInformes,
        [DatePicker.name]: DatePicker,
        [Select.name]: Select,
        [Dropdown.name]: Dropdown,
        [DropdownItem.name]: DropdownItem,
        [DropdownMenu.name]: DropdownMenu,
        [Button.name]: Button,
        [Option.name]: Option,
        [Checkbox.name]: Checkbox,
        [CheckboxGroup.name]: CheckboxGroup,
        [Switch.name]: Switch,
        CabeceraInformes
    },
    data() {
        return {
            loading: false,
            datefrom: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString(),
            dateto: new Date().toISOString(),
            listBusinesses: [],
            idBusiness: this.$route.params.idBusiness,
            value4: [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()],
            list: [],
            mode: 0,
            $Chart: null,
            objectChart: null,
            contador: 0,
            chartIn: 0,
            listTpv: [],
            idTpv: 0,
            dateRangeOptions1: {
                firstDayOfWeek: 1
            },
            listCheckBoxTpv: [],
            idsTPV: [],

            ordenacionProductos: 0,
            ordenarCantidad: 0,
            ordenarCantidadMenuCateg: 0,
            ordenarCantidadMenuCategDiferencia: 0,
            ordenarCantidadMenu: 0,
            ordenarCantidadMenuDiferencia: 0,
            ordenarImporte: 0,
            ordenarImporteSinIva: 0,
            ordenarPrecioMed: 0,
            ordenarPorcentaje: 0,
            totalCategorias: 0,
            totalProductos: 0,

            //DESGLOSE DE PRODUCT
            nameCate: "",
            listProduct: [],
            respuesta: true,
            checkValue: false,
            existeProducto: false,
            cantidadProd: 0,
            hayMenus: false,
            excluirMenu: false,
            listaDetallesMenu: [],
        }
    },
    computed: {
        ...mapState(["permiso"]),
        urlExportPDFDetalle() {
            var tpv = "";

            this.idsTPV.forEach(function (d) {
                tpv += d + ',';
            });

            return this.$store.getters.apiUrl + "/categories/exportVentasCategoriesDet/PDF?idBusiness=" + this.idBusiness + "&idTpv=" + tpv + "&nameCate=" + encodeURIComponent(this.nameCate) + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt + "&checkValue=" + this.checkValue
            // return "../api/public/index.php/categories/exportVentasCategoriesDet/PDF?idBusiness=" + this.idBusiness + "&idTpv=" + tpv + "&nameCate=" + this.nameCate + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt
        },

        urlExportExcelDetalle() {
            var tpv = "";

            this.idsTPV.forEach(function (d) {
                tpv += d + ',';
            })

            return this.$store.getters.apiUrl + "/categories/exportVentasCategoriesDet/Excel?idBusiness=" + this.idBusiness + "&idTpv=" + tpv + "&nameCate=" + encodeURIComponent(this.nameCate) + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt + "&checkValue=" + this.checkValue
        },

        urlExportPDF() {
            var tpv = "";

            this.idsTPV.forEach(function (d) {
                tpv += d + ',';
            });

            return this.$store.getters.apiUrl + "/categories/exportVentasCategories/PDF?idBusiness=" + this.idBusiness + "&idTpv=" + tpv + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt + "&checkValue=" + this.checkValue
        },

        urlExportExcel() {
            var tpv = "";

            this.idsTPV.forEach(function (d) {
                tpv += d + ',';
            })

            return this.$store.getters.apiUrl + "/categories/exportVentasCategories/Excel?idBusiness=" + this.idBusiness + "&idTpv=" + tpv + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt + "&checkValue=" + this.checkValue
        },

        getTotalPrecioProduct() {
            let total = 0;
            this.totalProductos = 0;

            this.listProduct.forEach(function (d) {
                // if(d.importe >= 0){ //hago esto para eliminar de la lista los descuentos y que no resten las ventas reales
                total += d.importe;
                // }else{
                //     total = total + 0
                // }
            });

            this.totalProductos = total;

            return total;
        },

        getTotalUdsProduct() {
            let totalud = 0;
            this.listProduct.forEach(function (d) {
                // if (d.name != "Descuento") {
                //     totalud += d.cantidad;
                // }
                // if(d.importe >=0 ){
                totalud += d.cantidad;
                // }else{
                //     totalud =totalud +0;  
                // }
            });

            return totalud;
        },

        getTotalUdsCategMenus() {
            let total = 0;
            this.list.forEach(function (d) {
                if (d.name != "Descuento") {
                    total += d.cantidadMenu;
                }
            });
            return total;
        },

        getTotalUdsMenus() {
            let total = 0;
            this.listProduct.forEach(function (d) {
                if (d.name != "Descuento") {
                    total += d.cantidadMenu;
                }
            });
            return total;
        },

        getTotalPrecio() {
            let total = 0;
            this.totalCategorias = 0;

            this.list.forEach(function (d) {
                // if(d.importe>=0){
                // this.list.products.forEach(function(d) {
                total += parseFloat(d.importe);
                // });

                // }else
                // total = total + 0;
            });

            this.totalCategorias = total;

            return total;
        },

        getTotalUds() {
            let totalud = 0;

            this.list.forEach(categoria => {
                categoria.products.forEach(producto => {
                    totalud += producto.cantidad;
                });
            });

            return totalud;
        },
        getTotalPrecioProductSinIva() {
            let total = 0;
            this.listProduct.forEach(function (d) {
                total += d.importeSinIva;
            });
            return total;
        },
        getTotalPrecioSinIva() {
            let total = 0;
            this.list.forEach(function (d) {
                total += parseFloat(d.importeSinIva);
            });
            return total;
        },
    },
    methods: {
        getPorcentajeCategorias(importe) {
            return (importe/this.totalCategorias*100).toFixed(2);
        },

        getPorcentajeProductos(importe) {
            return (importe/this.totalProductos*100).toFixed(2);
        },

        calcularMedia(obj) {
            let media = 0;

            if (this.excluirMenu) {
                media = obj.importe / (obj.cantidad - obj.cantidadMenu);
            } else {
                media = obj.importe / obj.cantidad;
            }

            return media;
        },

        abrirModalDetallesMenu(obj) {
            this.listaDetallesMenu = obj.menusPertenecientes;
            this.$modal.show('detallesMenu');
        },

        cerrarModalDetallesMenu() {
            this.$modal.hide('detallesMenu');
            this.listaDetallesMenu = [];
        },

        getTotalUdsCategoria(products) {
            let totalUdCat = 0;
            products.forEach(producto => {
                totalUdCat += producto.cantidad;
            })

            return totalUdCat;
        },

        getTotalUdsCategoriaMenu(products) {
            let totalUdCatMenu = 0;

            products.forEach(producto => {
                if (producto.cantidadMenu != null)
                    totalUdCatMenu += producto.cantidadMenu;
            })

            return totalUdCatMenu;
        },

        cambioBusiness(idBusinessData, listTpv) {
            if (listTpv) {
                this.listTpv = listTpv;
            }

            this.loading = Loading.service({ text: "Cargando..." });
            this.idBusiness = idBusinessData;
            this.idTpv = -1;
            this.idsTPV = [];
            this.list = [];
            this.cambioTpv(this.idTpv);
        },

        emitirConsulta() {
            this.nameCate = "";
            this.loading = Loading.service({ text: "Cargando..." });
            this.getSalesCategories();
        },

        cambioTpv(idTpvData, filtrar) {
            if (idTpvData != undefined) {
                this.idTpv = idTpvData;

                this.changeTPV();
            }

            this.idTpv = idTpvData;
            this.emitirConsulta();
        },

        cambioHora(dates) {
            this.datefrom = dates[0]
            this.dateto = dates[1]
        },

        accionarProductByCate(index, obj) {
            this.nameCate = obj.name;
            this.listProduct = obj.products;

            this.initChart()
            this.sortedArrayCantidadDESC();
        },

        volver() {
            this.nameCate = '';
            this.listProduct = [];
        },

        sortedArrayNameASC: function () {
            this.ordenacionProductos = 1;

            function compare(a, b) {
                const nameA = a.name ? a.name.toUpperCase() : "";
                const nameB = b.name ? b.name.toUpperCase() : "";

                if (nameA === "" && nameB === "") return 0;
                if (nameA === "") return 1;
                if (nameB === "") return -1;

                return nameA.localeCompare(nameB);
            }

            this.list.sort(compare);
            this.listProduct.sort(compare);
        },

        sortedArrayNameDESC: function () {
            this.ordenacionProductos = 0;

            function compare(a, b) {
                const nameA = a.name ? a.name.toUpperCase() : "";
                const nameB = b.name ? b.name.toUpperCase() : "";

                if (nameA === "" && nameB === "") return 0;
                if (nameA === "") return 1;
                if (nameB === "") return -1;

                return nameB.localeCompare(nameA);
            }

            this.list.sort(compare);
            this.listProduct.sort(compare);
        },


        sortedArrayCantidadASC: function () {
            this.ordenarCantidad = 1;

            function compare(a, b) {
                if (a.cantidad < b.cantidad)
                    return -1;
                if (a.cantidad > b.cantidad)
                    return 1;
                return 0;
            }

            this.list.sort(compare);
            this.listProduct.sort(compare);
        },

        sortedArrayCantidadDESC: function () {
            this.ordenarCantidad = 0;

            function compare(a, b) {
                if (a.cantidad > b.cantidad)
                    return -1;
                if (a.cantidad < b.cantidad)
                    return 1;
                return 0;
            }

            this.list.sort(compare);
            this.listProduct.sort(compare);
        },

        sortedArrayCantidadMenuCategASC: function () {
            this.ordenarCantidadMenuCateg = 1;
            this.ordenarCantidadMenu = 1;

            function compare(a, b) {
                if (a.cantidadMenu < b.cantidadMenu)
                    return -1;
                if (a.cantidadMenu > b.cantidadMenu)
                    return 1;
                return 0;
            }

            this.list.sort(compare);
            this.listProduct.sort(compare);
        },

        sortedArrayCantidadMenuCategDESC: function () {
            this.ordenarCantidadMenuCateg = 0;
            this.ordenarCantidadMenu = 0;

            function compare(a, b) {
                if (a.cantidadMenu > b.cantidadMenu)
                    return -1;
                if (a.cantidadMenu < b.cantidadMenu)
                    return 1;
                return 0;
            }

            this.list.sort(compare);
            this.listProduct.sort(compare);
        },

        sortedArrayCantidadMenuCategDiferenciaASC: function () {
            this.ordenarCantidadMenuCateg = 1;
            this.ordenarCantidadMenuDiferencia = 1;

            function compare(a, b) {
                if ((a.cantidad - a.cantidadMenu) < (b.cantidad - b.cantidadMenu)) return -1;
                if ((a.cantidad - a.cantidadMenu) > (b.cantidad - b.cantidadMenu)) return 1;
                return 0;
            }

            this.list.sort(compare);
            this.listProduct.sort(compare);
        },

        sortedArrayCantidadMenuCategDiferenciaDESC: function () {
            this.ordenarCantidadMenuCateg = 0;
            this.ordenarCantidadMenuDiferencia = 0;

            function compare(a, b) {
                if ((a.cantidad - a.cantidadMenu) > (b.cantidad - b.cantidadMenu)) return -1;
                if ((a.cantidad - a.cantidadMenu) < (b.cantidad - b.cantidadMenu)) return 1;
                return 0;
            }

            this.list.sort(compare);
            this.listProduct.sort(compare);
        },

        sortedArrayCantidadMenuASC: function () {
            this.ordenarCantidadMenu = 1;

            function compare(a, b) {
                if (a.cantidadMenu < b.cantidadMenu) return -1;
                if (a.cantidadMenu > b.cantidadMenu) return 1;
                return 0;
            }

            this.listProduct.sort(compare);
        },

        sortedArrayCantidadMenuDESC: function () {
            this.ordenarCantidadMenu = 0;

            function compare(a, b) {
                if (a.cantidadMenu > b.cantidadMenu) return -1;
                if (a.cantidadMenu < b.cantidadMenu) return 1;
                return 0;
            }

            this.listProduct.sort(compare);
        },

        sortedArrayCantidadMenuDiferenciaASC: function () {
            this.ordenarCantidadMenuDiferencia = 1;

            function compare(a, b) {
                if ((a.cantidad - a.cantidadMenu) < (b.cantidad - b.cantidadMenu)) return -1;
                if ((a.cantidad - a.cantidadMenu) > (b.cantidad - b.cantidadMenu)) return 1;
                return 0;
            }

            this.listProduct.sort(compare);
        },

        sortedArrayCantidadMenuDiferenciaDESC: function () {
            this.ordenarCantidadMenuDiferencia = 0;

            function compare(a, b) {
                if ((a.cantidad - a.cantidadMenu) > (b.cantidad - b.cantidadMenu)) return -1;
                if ((a.cantidad - a.cantidadMenu) < (b.cantidad - b.cantidadMenu)) return 1;
                return 0;
            }

            this.list.sort(compare);
        },

        sortedArrayImporteASC: function () {
            this.ordenarImporte = 1;

            function compare(a, b) {
                if (a.importe < b.importe)
                    return -1;
                if (a.importe > b.importe)
                    return 1;
                return 0;
            }

            this.list.sort(compare);
            this.listProduct.sort(compare);
        },

        sortedArrayImporteDESC: function () {
            this.ordenarImporte = 0;

            function compare(a, b) {
                if (a.importe > b.importe)
                    return -1;
                if (a.importe < b.importe)
                    return 1;
                return 0;
            }

            this.list.sort(compare);
            this.listProduct.sort(compare);
        },

        sortedArrayImporteSinIvaASC: function () {
            this.ordenarImporteSinIva = 1;

            function compare(a, b) {
                if (a.importeSinIva < b.importeSinIva)
                    return -1;
                if (a.importeSinIva > b.importeSinIva)
                    return 1;
                return 0;
            }

            this.list.sort(compare);
            this.listProduct.sort(compare);
        },

        sortedArrayImporteSinIvaDESC: function () {
            this.ordenarImporteSinIva = 0;

            function compare(a, b) {
                if (a.importeSinIva > b.importeSinIva)
                    return -1;
                if (a.importeSinIva < b.importeSinIva)
                    return 1;
                return 0;
            }

            this.list.sort(compare);
            this.listProduct.sort(compare);
        },

        sortedPorcentajeASC: function () {
            this.ordenarPorcentaje = 1;

            function compare(a, b) {
                if (a.importe < b.importe)
                    return -1;
                if (a.importe > b.importe)
                    return 1;
                return 0;
            }

            this.list.sort(compare);
            this.listProduct.sort(compare);
        },

        sortedPorcentajeDESC: function () {
            this.ordenarPorcentaje = 0;

            function compare(a, b) {
                if (a.importe > b.importe)
                    return -1;
                if (a.importe < b.importe)
                    return 1;
                return 0;
            }

            this.list.sort(compare);
            this.listProduct.sort(compare);
        },

        sortedArrayPrecioMedASC: function () {
            this.ordenarPrecioMed = 1;

            function compare(a, b) {
                if (a.importe / a.cantidad < b.importe / b.cantidad)
                    return -1;
                if (a.importe / a.cantidad > b.importe / b.cantidad)
                    return 1;
                return 0;
            }

            this.list.sort(compare);
            this.listProduct.sort(compare);
        },

        sortedArrayPrecioMedDESC: function () {
            this.ordenarPrecioMed = 0;

            function compare(a, b) {
                if (a.importe / a.cantidad > b.importe / b.cantidad)
                    return -1;
                if (a.importe / a.cantidad < b.importe / b.cantidad)
                    return 1;
                return 0;
            }

            this.list.sort(compare);
            this.listProduct.sort(compare);
        },

        //ORDENAR PRODUCTOS
        changeTPV() {
            if (this.idTpv === -1) {
                this.idsTPV = [];

                for (let i = 0; i < this.listTpv.length; i++) {
                    this.idsTPV.push(this.listTpv[i].id)
                }

            } else {
                this.idsTPV = []
                this.idsTPV.push(this.idTpv)
            }
            //this.getSalesCategories();
        },

        openModal() {
            this.$modal.show('filtradoTPV');
        },

        getTpv() {
            this.listTpv = [];

            var config = {
                params: {
                    idBusiness: this.idBusiness,
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
                .then(function (response) {
                    if (response.data.response) {
                        for (let i = 0; i < response.data.result.length; i++) {
                            vm.idsTPV.push(response.data.result[i].id)
                        }

                        vm.listCheckBoxTpv = response.data.result;

                        for (let i = 0; i < response.data.result.length; i++) {
                            let printername = {
                                nameShow: response.data.result[i].nameShow,
                                id: response.data.result[i].id
                            };

                            vm.listTpv.push(printername)
                        }

                        //RESETEO LAS VARIABLES
                        vm.listProduct = [];
                        vm.nameCate = '';

                        vm.getSalesCategories();
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        getBusiness() {
            var config = {
                params: {
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
                .then(function (response) {
                    vm.listBusinesses = response.data.result;

                    if (vm.$store.getters.idBusiness) {
                        vm.idBusiness = vm.$store.getters.idBusiness;
                    } else {
                        vm.idBusiness = response.data.result[0].id;
                    }

                    vm.getTpv();
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        getSalesCategories() {
            this.list = [];
            this.$modal.hide('filtradoTPV');

            if (this.datefrom === null || this.dateto === null) {
                swal({
                    title: this.$t('ups'),
                    text: this.$t('seleccioneUnaFechaDeInicioYUnaFechaDeFin'),
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });

                this.loading.close();

            } else {
                let secondsDesde = moment(this.datefrom).unix();
                let secondsHasta = moment(this.dateto).unix();

                if (secondsHasta < secondsDesde) {
                    swal({
                        title: this.$t('ups'),
                        text: this.$t('laFechaDeInicioNoPuedeSerPosteriorALaDeFin'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                    this.loading.close();

                } else {
                    this.$store.dispatch("setDateTo", this.dateto);
                    this.$store.dispatch("setDateFrom", this.datefrom);

                    var config = {
                        params: {
                            idBusiness: this.idBusiness,
                            datefrom: moment(this.datefrom).startOf("day").unix(),
                            dateto: moment(this.dateto).endOf("day").unix(),
                            idTpv: this.idsTPV,
                            jwt: this.$store.getters.jwt,
                            checkValue: this.checkValue
                        },
                        headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
                    };

                    let vm = this;
                    this.axios.get(this.$store.getters.apiUrl + "categories/getSalesCategorias", config)
                        .then(function (response) {
                            if (response.data.response) {

                                vm.respuesta = true;

                                vm.list = response.data.result.ventasCategorias;
                                vm.hayMenus = vm.list.some(element => element.products.some(element2 => element2.isMenu));
                                vm.existeProducto = response.data.result.existeProducto;

                                vm.sortedArrayCantidadDESC();

                                vm.initChart()

                            } else if (response.data.response == false && response.data.rangoMayor == true) {
                                swal({
                                    title: "Lo sentimos",
                                    text: response.data.result,
                                    confirmButtonClass: "btn btn-info btn-fill",
                                    type: "info",
                                });
                                vm.respuesta = false;
                            }
                            else {
                                swal({
                                    title: vm.$t('accesoDenegado'),
                                    text: vm.$t('noTienesPermisoParaVisualizarEsteInforme'),
                                    confirmButtonClass: 'btn btn-info btn-fill',
                                    type: 'error'
                                });

                                vm.respuesta = false;
                            }
                            vm.loading.close();

                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                }
            }
        },

        initChart() {
            if (this.chartIn === 0) {
                if (this.nameCate !== '') {

                    var labels = this.listProduct.map(function (x) {
                        return x.name;
                    });

                    var data = this.listProduct.map(function (x) {
                        return x.cantidad;
                    });

                } else {

                    var labels = this.list.map(function (x) {
                        return x.name;
                    });

                    var data = this.list.map(function (x) {
                        return x.cantidad;
                    });
                }
            } else {
                if (this.nameCate !== '') {

                    var labels = this.listProduct.map(function (x) {
                        return x.name;
                    });

                    var data = this.listProduct.map(function (x) {
                        return x.importe;
                    });

                } else {

                    var labels = this.list.map(function (x) {
                        return x.name;
                    });

                    var data = this.list.map(function (x) {
                        return x.importe;
                    });
                }
            }

            var randomColor = require('randomcolor');
            var colors = randomColor({ luminosity: 'dark', count: labels.length, format: 'rgb' });

            let backgroundColors = colors.map(function (x) {
                let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
                return "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 0.6)";
            });

            let borderColors = colors.map(function (x) {
                let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
                return "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 0.3)";
            });

            let hoverBackgroundColors = colors.map(function (x) {
                let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
                return "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 1)";
            });

            if (this.contador === 0) {
                if (this.list.length > 0) {

                    this.objectChart = new Chart("chart", {
                        type: 'pie',
                        data: {
                            labels: labels,
                            datasets: [{
                                data: data,
                                backgroundColor: backgroundColors,
                                borderColor: borderColors,
                                hoverBackgroundColor: hoverBackgroundColors,
                                borderWidth: 1
                            }]
                        },
                        options: {
                            legend: {
                                display: true,
                                position: 'bottom',


                            },
                            responsive: true,
                            maintainAspectRatio: false,
                        }
                    });

                    this.contador++;
                }
            } else {
                this.objectChart.destroy();

                this.objectChart = new Chart("chart", {
                    type: 'pie',
                    data: {
                        labels: labels,
                        datasets: [{
                            data: data,
                            backgroundColor: backgroundColors,
                            borderColor: borderColors,
                            hoverBackgroundColor: hoverBackgroundColors,
                            borderWidth: 1
                        }]
                    },
                    options: {
                        legend: {
                            display: true,
                            position: 'bottom'
                        },
                        responsive: true,
                        maintainAspectRatio: false
                    }
                });
            }
        }
    }
}
</script>

<style scoped>
a li {
    color: #111;
}

.card {
    padding: 20px;
}

.div-export {
    margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Categorias/VentasCategorias.vue